import React from "react";
import "./Brands.css";

const logos = [
  "google", "linux", "intel", "netflix", "apple",
  "meta", "spotify", "wordpress", "airbnb", "uber",
  "line", "shopify", "dropbox", "paypal", "x",
  "indeed", "youtube", "figma", "github", "whatsapp",
  "tiktok", "snapchat", "pinterest", "reddit", "discord"
];

export default function Brands() {
  return (
    <section id="brands" className="brands-section">
      <h2 className="brands-title">Brands Who Trust Us</h2>

      <div className="brands-grid">
        {logos.map((brand, index) => (
          <div className="brand-tile" key={index}>
            <img
              src={require(`../assets/brands/${brand}.svg`)}
              alt={brand}
              // loading="lazy"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
